var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createElement } from 'react';
import { Form } from 'antd';
import { useDeepFormItem, FormItemShallowProvider, useShallowFormItem } from '../context';
import { normalizeCol, pickFormItemProps } from '../shared';
import { MegaLayoutItem } from '../components/FormMegaLayout/index';
var computeStatus = function (props) {
    if (props.loading) {
        return 'validating';
    }
    if (props.invalid) {
        return 'error';
    }
    if (props.warnings && props.warnings.length) {
        return 'warning';
    }
    return '';
};
var computeHelp = function (props) {
    if (props.help)
        return props.help;
    var messages = [].concat(props.errors || [], props.warnings || []);
    return messages.length
        ? messages.map(function (message, index) {
            return createElement('span', { key: index }, message, messages.length - 1 > index ? ' ,' : '');
        })
        : props.schema && props.schema.description;
};
var computeLabel = function (props) {
    if (props.label)
        return props.label;
    if (props.schema && props.schema.title) {
        return props.schema.title;
    }
};
var computeExtra = function (props) {
    if (props.extra)
        return props.extra;
};
var computeSchemaExtendProps = function (props) {
    if (props.schema) {
        return pickFormItemProps(__assign(__assign({}, props.schema.getExtendsItemProps()), props.schema.getExtendsProps()));
    }
};
export var AntdSchemaFieldAdaptor = function (props) {
    var _a = useDeepFormItem(), prefixCls = _a.prefixCls, labelAlign = _a.labelAlign, contextLabelCol = _a.labelCol, contextWrapperCol = _a.wrapperCol, size = _a.size;
    var help = computeHelp(props);
    var label = computeLabel(props);
    var status = computeStatus(props);
    var extra = computeExtra(props);
    var formItemProps = pickFormItemProps(props);
    var schemaItemProps = computeSchemaExtendProps(props);
    var formItemShallowProps = useShallowFormItem();
    var mergedProps = __assign(__assign(__assign({ label: label }, formItemShallowProps), formItemProps), schemaItemProps);
    var labelCol = mergedProps.labelCol, wrapperCol = mergedProps.wrapperCol;
    var addonAfter = mergedProps.addonAfter;
    delete mergedProps.addonAfter;
    var itemProps = __assign(__assign({ prefixCls: prefixCls,
        labelAlign: labelAlign,
        help: help, validateStatus: status, extra: extra ? React.createElement("p", null, extra) : undefined }, mergedProps), { required: props.editable === false ? undefined : props.required, labelCol: label ? normalizeCol(labelCol || contextLabelCol) : {}, wrapperCol: label ? normalizeCol(wrapperCol || contextWrapperCol) : {} });
    var renderComponent = function (children, opts) {
        var addonAfter = (opts || {}).addonAfter;
        return addonAfter ? (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(FormItemShallowProvider, null, children),
            addonAfter)) : (React.createElement(FormItemShallowProvider, null, children));
    };
    return React.createElement(MegaLayoutItem, __assign({ itemProps: __assign(__assign({}, itemProps), { size: size }) }, props.props, { schemaChildren: props.children }), function (megaComponent) {
        if (megaComponent) {
            return renderComponent(megaComponent, { addonAfter: addonAfter });
        }
        return React.createElement(Form.Item, __assign({}, itemProps), renderComponent(props.children, { addonAfter: addonAfter }));
    });
};
